import { useEffect } from "react";
import { NavigateFunction, useNavigate } from "react-router-dom";

export let globalNavigate: NavigateFunction | null = null;

export const useGlobalNavigate = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (globalNavigate) {
      return;
    }

    globalNavigate = navigate;
  }, [navigate]);
};
